import axios from 'axios'
import qs from 'qs'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Impuestos
    taxes: {
      tableData: [],
      totalTaxes: 0
    },
    queryTaxes: {
      page: 0,
      size: 20,
      sort: 'enable,DESC',
      type: null,
      rate: null,
      country: null,
      dateFrom: null,
      dateTo: null,
      enable: null,
      project: null
    },
    listSelectedFiltersTaxes: [],

    // Datos Select Filtros Impuestos
    optionsFilterTypeTaxes: [],
    optionsFilterRateTaxes: [],
    optionsFilterCountryTaxes: []
  }
  return session
}
function initLocal () {
  const local = {
    // Columnas Tabla Impuestos
    isShowTypeTaxes: true,
    isShowRateTaxes: true,
    isShowProjectTaxes: true,
    isShowDateFromTaxes: true,
    isShowDateToTaxes: true,
    isShowCountryTaxes: true,
    isShowEnabledTaxes: true

  }
  return local
}
function setByUserLocalTax () {
  const local = {
    // Columnas Tabla Impuestos
    isShowTypeTaxes: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).taxes.isShowTypeTaxes,
    isShowRateTaxes: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).taxes.isShowRateTaxes,
    isShowDateFromTaxes: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).taxes.isShowDateFromTaxes,
    isShowDateToTaxes: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).taxes.isShowDateToTaxes,
    isShowCountryTaxes: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).taxes.isShowCountryTaxes,
    isShowEnabledTaxes: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).taxes.isShowEnabledTaxes,
    isShowProjectTaxes: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).taxes.isShowProjectTaxes
  }
  return local
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {
    // Columnas Tabla Impuestos
    isShowTypeTaxes: true,
    isShowRateTaxes: true,
    isShowDateFromTaxes: true,
    isShowDateToTaxes: true,
    isShowCountryTaxes: true,
    isShowEnabledTaxes: true,
    isShowProjectTaxes: true
  },
  session: initSession()
}

// getters
const getters = {

  // Datos Tabla Impuestos
  taxes: state => {
    return state.session.taxes
  },
  queryTaxes: state => {
    return state.session.queryTaxes
  },
  listSelectedFiltersTaxes: state => {
    return state.session.listSelectedFiltersTaxes
  },

  // Datos Select Filtros Impuestos
  optionsFilterTypeTaxes: state => {
    return state.session.optionsFilterTypeTaxes
  },
  optionsFilterRateTaxes: state => {
    return state.session.optionsFilterRateTaxes
  },
  optionsFilterCountryTaxes: state => {
    return state.session.optionsFilterCountryTaxes
  },

  // Columnas Tabla Impuestos
  isShowTypeTaxes: state => {
    return state.local.isShowTypeTaxes
  },
  isShowRateTaxes: state => {
    return state.local.isShowRateTaxes
  },
  isShowProjectTaxes: state => {
    return state.local.isShowProjectTaxes
  },
  isShowCountryTaxes: state => {
    return state.local.isShowCountryTaxes
  },
  isShowDateFromTaxes: state => {
    return state.local.isShowDateFromTaxes
  },
  isShowDateToTaxes: state => {
    return state.local.isShowDateToTaxes
  },
  isShowEnabledTaxes: state => {
    return state.local.isShowEnabledTaxes
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNameTax ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalTax()
    }
  },
  async isNewVersionTaxesLocalState ({ state }, localStorage) {
    const isnew = await fn.isNewVersion(state, localStorage.taxes)
    return isnew
  },

  /* TAXES */
  /**
  * Servicio para traer las Impuestos .
  * Se utiliza también para ordenar la tabla, la paginación,
  * el tamaño de la tabla y los filtros.
  */
  async getTaxes ({ commit, rootState }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/tax',
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      console.log('RESPONSE getTaxes:: ', response)

      commit('TAXES_STATE', {
        tableData: response.data.content,
        totalTaxes: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Modifica un impuesto */
  async modifyTax ({ commit, rootState }, data) {
    try {
      let urlName
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/tax/' + data.taxId,
        data: {
          project: data.project,
          type: data.taxType,
          rate: data.taxRate,
          country: data.country,
          enable: data.enable,
          legalText: data.legalText,
          dateFrom: data.dateFrom,
          dateTo: data.dateTo,
          urlName: urlName
        }
      })

      console.log('RESPONSE modifyTax:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Activa/desactiva un impuesto */
  async activeTax ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/tax/' + request.taxId + '/enable',
        params: {
          enable: request.enable
        }
      })
      console.log('RESPONSE modifyTax:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Activa/desactiva el flag de global de un texto legal */
  async updateGlobalLegalText ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/tax/' + request.legalTextId + '/updateGlobalText',
        params: {
          global: request.global
        }
      })
      console.log('RESPONSE updateGlobalLegalText:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para eliminar un impuesto
   * @param {*} roleId
   */
  async deleteTax ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/tax/' + params.taxId
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Servicio para traer detalle de un impuesto
  async getTaxDetail ({ commit, rootState }, taxId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/tax/' + taxId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Datos Tabla Impuestos
  taxesState: ({ commit }, payload) => {
    commit('TAXES_STATE', payload)
  },
  queryTaxesState: ({ commit }, payload) => {
    commit('QUERY_TAXES_STATE', payload)
  },
  listSelectedFiltersTaxesState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_TAXES_STATE', payload)
  },

  // Datos Select Filtros Impuestos
  optionsFilterTypeTaxesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_TYPE_TAXES', payload)
  },
  optionsFilterRateTaxesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_RATE_TAXES', payload)
  },
  optionsFilterCountryTaxesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_COUNTRY_TAXES', payload)
  },
  // Columnas Tabla Impuestos
  isShowTypeTaxesAction: ({ commit }, payload) => {
    commit('IS_SHOW_TYPE_TAXES', payload)
  },
  isShowRateTaxesAction: ({ commit }, payload) => {
    commit('IS_SHOW_RATE_TAXES', payload)
  },
  isShowProjectTaxesAction: ({ commit }, payload) => {
    commit('IS_SHOW_PROJECT_TAXES', payload)
  },
  isShowCountryTaxesAction: ({ commit }, payload) => {
    commit('IS_SHOW_COUNTRY_TAXES', payload)
  },
  isShowDateFromTaxesAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_FROM_TAXES', payload)
  },
  isShowDateToTaxesAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_TO_TAXES', payload)
  },
  isShowEnabledTaxesAction: ({ commit }, payload) => {
    commit('IS_SHOW_ENABLE_TAXES', payload)
  }
}

// mutations
const mutations = {
  resetSessionTaxes (state) {
    state.session = initSession()
    state.local = initLocal()
  },

  // Impuestos
  'TAXES_STATE' (state, payload) {
    state.session.taxes = payload
  },
  'QUERY_TAXES_STATE' (state, payload) {
    state.session.queryTaxes = payload
  },
  'LIST_SELECTED_FILTERS_TAXES_STATE' (state, payload) {
    state.session.listSelectedFiltersTaxes = payload
  },

  // Datos Select Filtros Impuestos
  'OPTIONS_FILTER_TYPE_TAXES' (state, payload) {
    state.session.optionsFilterTypeTaxes = payload
  },
  'OPTIONS_FILTER_RATE_TAXES' (state, payload) {
    state.session.optionsFilterRateTaxes = payload
  },
  'OPTIONS_FILTER_COUNTRY_TAXES' (state, payload) {
    state.session.optionsFilterCountryTaxes = payload
  },

  // Columnas Tabla  Impuestos
  'IS_SHOW_TYPE_TAXES' (state, payload) {
    state.local.isShowTypeTaxes = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.taxes.isShowTypeTaxes = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_RATE_TAXES' (state, payload) {
    state.local.isShowRateTaxes = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.taxes.isShowRateTaxes = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PROJECT_TAXES' (state, payload) {
    state.local.isShowProjectTaxes = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.taxes.isShowProjectTaxes = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_COUNTRY_TAXES' (state, payload) {
    state.local.isShowCountryTaxes = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.taxes.isShowCountryTaxes = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_FROM_TAXES' (state, payload) {
    state.local.isShowDateFromTaxes = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.taxes.isShowDateFromTaxes = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_TO_TAXES' (state, payload) {
    state.local.isShowDateToTaxes = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.taxes.isShowDateToTaxes = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ENABLE_TAXES' (state, payload) {
    state.local.isShowEnabledTaxes = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.taxes.isShowEnabledTaxes = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
